import EditorTooltipContainer from './EditorTooltipContainer'
export { EditorTooltipContainer }
export default EditorTooltipContainer



// WEBPACK FOOTER //
// ./src/components/EditorTooltip/index.js